import { render, staticRenderFns } from "./OrdersArchived.vue?vue&type=template&id=72bf6338"
import script from "./OrdersArchived.vue?vue&type=script&lang=js"
export * from "./OrdersArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports